import { useEffect } from "react";
import { useInput } from "../../hooks/use-Input";
import Input from "../UI/Input";
import styles from "./FormControls.module.css";

const FormControls = (props) => {
  const {
    formState: nameState,
    validateValue: nameValidate,
    changeInputHandler: changeNameHandler,
    blurInputHandler: blurNameInputHandler,
  } = useInput();
  const {
    formState: mobileState,
    validateValue: mobileValidate,
    changeInputHandler: changeMobileHandler,
    blurInputHandler: blurMobileInputHandler,
  } = useInput();
  const {
    formState: emailState,
    validateValue: emailValidate,
    changeInputHandler: changeEmailHandler,
    blurInputHandler: blurEmailInputHandler,
  } = useInput();
  const {
    formState: availState,
    validateValue: availValidate,
    changeInputHandler: changeAvailHandler,
    blurInputHandler: blurAvailInputHandler,
  } = useInput();
  const {
    formState: attorneysState,
    changeInputHandler: changeAttorneyHandler,
  } = useInput();

  useEffect(() => {
    if (nameState.isTouched) {
      setTimeout(() => {
        nameValidate({
          value: nameState.enteredValue,
          type: "text",
        });
      }, 500);
    }
  }, [
    nameValidate,
    nameState.isTouched,
    nameState.enteredValue,
  ]);
  useEffect(() => {
    if (mobileState.isTouched) {
      setTimeout(() => {
        mobileValidate({
          value: mobileState.enteredValue,
          type: "mobile",
        });
      }, 500);
    }
  }, [
    mobileValidate,
    mobileState.isTouched,
    mobileState.enteredValue,
  ]);
  useEffect(() => {
    if (emailState.isTouched) {
      setTimeout(() => {
        emailValidate({
          value: emailState.enteredValue,
          type: "email",
        });
      }, 500);
    }
  }, [
    emailValidate,
    emailState.isTouched,
    emailState.enteredValue,
  ]);
  useEffect(() => {
    if (availState.isTouched) {
      setTimeout(() => {
        availValidate({
          value: availState.enteredValue,
          type: "text",
        });
      }, 500);
    }
  }, [
    availValidate,
    availState.isTouched,
    availState.enteredValue,
  ]);

  useEffect(() => {
    if (
      nameState.isValid &&
      mobileState.isValid &&
      emailState.isValid &&
      availState.isValid
    ) {
      props.onGetFormData({
        name: nameState.enteredValue,
        mobile: mobileState.enteredValue,
        email: emailState.enteredValue,
        available_Practice:
          availState.enteredValue,
      });
    }
  }, [
    props,
    nameState,
    mobileState,
    emailState,
    availState,
  ]);

  return (
    <div className={styles.form_controls}>
      <div className={styles.form_control}>
        {nameState.error.hasError && (
          <div className={styles.error}>
            <label>
              Name <span>*</span>
            </label>
            <p id="error">
              {nameState.error.errorName}
            </p>
          </div>
        )}
        {!nameState.error.hasError && (
          <label>Name</label>
        )}

        <Input
          type="text"
          value={nameState.enteredValue}
          onChange={changeNameHandler}
          onBlur={blurNameInputHandler}
          className={
            !nameState.isValid &&
            nameState.isTouched
              ? styles["invalid"]
              : ""
          }
        />
      </div>
      <div className={styles.form_control}>
        {mobileState.error.hasError && (
          <div className={styles.error}>
            <label>
              Mobile <span>*</span>
            </label>
            <p id="error">
              {mobileState.error.errorName}
            </p>
          </div>
        )}
        {!mobileState.error.hasError && (
          <label>Mobile</label>
        )}
        <Input
          type="tel"
          value={mobileState.enteredValue}
          onChange={changeMobileHandler}
          onBlur={blurMobileInputHandler}
          className={
            !mobileState.isValid &&
            mobileState.isTouched
              ? styles["invalid"]
              : ""
          }
        />
      </div>
      <div className={styles.form_control}>
        {emailState.error.hasError && (
          <div className={styles.error}>
            <label>
              Email <span>*</span>
            </label>
            <p id="error">
              {emailState.error.errorName}
            </p>
          </div>
        )}
        {!emailState.error.hasError && (
          <label>Email</label>
        )}
        <Input
          type="email"
          value={emailState.enteredValue}
          onChange={changeEmailHandler}
          onBlur={blurEmailInputHandler}
          className={
            !emailState.isValid &&
            emailState.isTouched
              ? styles["invalid"]
              : ""
          }
        />
      </div>
      <div className={styles.form_control}>
        {availState.error.hasError && (
          <div className={styles.error}>
            <label>
              Available Practice <span>*</span>
            </label>
            <p id="error">
              {availState.error.errorName}
            </p>
          </div>
        )}
        {!availState.error.hasError && (
          <label>Available Practice</label>
        )}

        <Input
          type="text"
          value={availState.enteredValue}
          onChange={changeAvailHandler}
          onBlur={blurAvailInputHandler}
          className={
            !availState.isValid &&
            availState.isTouched
              ? styles["invalid"]
              : ""
          }
        />
      </div>
      <div className={styles.form_control}>
        <label>Attorneys</label>
        <Input
          type="text"
          value={attorneysState.enteredValue}
          onChange={changeAttorneyHandler}
        />
      </div>
    </div>
  );
};

export default FormControls;
